import {
  FormControl,
  InputBase,
  MenuItem,
  Select,
  SelectChangeEvent,
  styled,
} from '@mui/material';

const StyledInput = styled(InputBase)(() => ({
  '& .MuiInputBase-input': {
    fontWeight: 500,
  },
}));

export type Option = {
  name: string;
  value: string;
};

export type OptimizationSelectProps<T extends Option> = {
  selectedOptimization: T;
  setSelectedOptimization: (optimization: T['value']) => void;
  options: readonly T[];
};

export const OptimizationSelectV2 = <T extends Option>(
  props: OptimizationSelectProps<T>
) => {
  if (props.options.length === 1) return props.selectedOptimization.name;

  const handleChange = (event: SelectChangeEvent<string>) => {
    const {
      target: { value },
    } = event;
    props.setSelectedOptimization(value as T['value']);
  };

  return (
    <FormControl fullWidth>
      <Select
        disableUnderline
        variant="standard"
        value={props.selectedOptimization.value}
        onChange={handleChange}
        onClick={e => e.stopPropagation()}
        input={<StyledInput />}
      >
        {props.options.map(option => (
          <MenuItem key={option.value} value={option.value}>
            {option.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
